// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_AvailableCashRecebimentosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_OpenAdvancesForPeriodCashRecebimentoRow } from './Payroll_OpenAdvancesForPeriodCashRecebimentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Payroll_AvailableCashRecebimentosResponseDados = Payroll_OpenAdvancesForPeriodCashRecebimentoRow[];

export type Payroll_AvailableCashRecebimentosResponse = ApiResponse<Payroll_AvailableCashRecebimentosResponseDados>;

registerResponseContract('Payroll_AvailableCashRecebimentosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      recebimento_id:                 { type: 'number',  required: true },
      recebimento_data:               { type: 'string',  required: false },
      recebimento_valor:              { type: 'number',  required: false },
      amount_reais:                   { type: 'string',  required: false },
      recebimento_forma_pagamento_id: { type: 'number',  required: false },
      forma_pagamento_nome:           { type: 'string',  required: true },
      compromisso_id:                 { type: 'number',  required: true },
      operador_user_id:               { type: 'string',  required: false },
      cliente_nome:                   { type: 'string',  required: false },
      operador_name:                  { type: 'string',  required: false },
    },
  },
})
